import { useEffect } from 'react';

import { useCompetencyDrawerState } from '../competencyDrawerSlice';
import { useCompetencyQueryParams } from './useCompetencyQueryParams';
import { useOpenCompetencyDrawer } from './useOpenCompetencyDrawer';

export const useDrawerOnQueryChange = () => {
  const { competencyId, employeeId, isCompetencyPanelOpen } = useCompetencyQueryParams();

  const { isOpen } = useCompetencyDrawerState();
  const { openCompetencyPanel } = useOpenCompetencyDrawer();

  useEffect(() => {
    if (!isOpen && competencyId && employeeId && isCompetencyPanelOpen === 'true') {
      openCompetencyPanel({
        tagId: competencyId,
        employeeId,
      });
    }
  }, [competencyId, employeeId, isOpen, openCompetencyPanel, isCompetencyPanelOpen]);
};
